<div *transloco="let t" class="grid grid-rows-1 grid-cols-8 w-full">
	<div [class]="isFilterSelected() ? customClassIfFilterSelected : customClass">
		<mat-form-field class="w-full" appearance="fill" color="primary" [style]="customStyle()">
			<mat-label>
				@if (finishedLoading()()) {
					{{ label() }}
				} @else {
					<mat-spinner class="spinner" diameter="20"></mat-spinner>
				}
			</mat-label>
			<mat-select [formControl]="dataMultiCtrl()" [multiple]="true" #multiSelect (openedChange)="emitFiltersWhenClosed($event)">
				<mat-option>
					<ngx-mat-select-search
						(toggleAll)="toggleSelectAll($event)"
						[formControl]="dataMultiFilterCtrl"
						[placeholderLabel]="label().length > 0 ? label() : ''"
						[showToggleAllCheckbox]="true"
						[toggleAllCheckboxChecked]="isChecked"
						[toggleAllCheckboxIndeterminate]="isIndeterminate"></ngx-mat-select-search>
				</mat-option>
				@for (option of filteredDataMulti(); track option) {
					<mat-option [value]="option">
						{{ beautifyOption(option) }}
					</mat-option>
				}
			</mat-select>
		</mat-form-field>
	</div>
	@if (this.isFilterSelected()) {
		<div class="col-start-8">
			<button (click)="clearSelection()" mat-icon-button name="clearFilter">
				<mat-icon [matTooltip]="t('devices.tooltip.clearFilterTooltip')" [svgIcon]="icons.get('filterOff')"></mat-icon>
			</button>
		</div>
	}
</div>
